import React, {useEffect, useState} from 'react';
import {Box, Button, Table, TableBody, TableHead} from "@mui/material";
import {StyledTableCell, StyledTableRow} from '../common/table/TableStyles';
import TableLoadingMockup from "../common/table/TableLoadingMockup";
import Typography from "@mui/material/Typography";
import DailyReconciliationWindow from "./DailyReconciliationWindow";
import {
    useGetDailyReconciliationsQuery,
    useUpdateDailyReconciliationsVisitMutation
} from "../../store/rtk-api/daily_reconciliations/daily_reconciliations";
import IsError from "../common/IsError";
import {IDailyReconciliationsResults, IUpdateBody} from "../../store/rtk-api/daily_reconciliations/types";
import {setReconciliationsCount} from "../../store/calendar/calendar.slice";
import {useAppDispatch} from "../../store";

type Props = {
    rowsPerPage: number,
    query: string,
    filterPage: number | undefined
}

const mapping = {
    'visitDate': 'Дата визита',
    'visitTime': 'Время визита',
    'doctorName': 'Врач',
    'patient': 'Пациент',
    'status': 'Статус',
    'button': '',

}

const statuses = {
    false: "Не посетил",
    true: "Посетил"
}

const DailyReconciliationList: React.FC<Props> = ({rowsPerPage, query, filterPage}) => {
    const dispatch = useAppDispatch()
    const [isOpen, setOpen] = useState(false)
    const [isVisited, setVisited] = useState(false)
    const [patientName, setPatientName] = useState('')
    const [patientPhone, setPatientPhone] = useState('')
    const [date, setDate] = useState('')
    const [doctorName, setDoctorName] = useState('')
    const [doctorPhoto, setDoctorPhoto] = useState('')
    const [recId, setRecId] = useState<number | null>(null)
    const [updateStatus, {
        isLoading: deleteLoading,
        isError: deletingProductError,
        isSuccess
    }] = useUpdateDailyReconciliationsVisitMutation()
    const handleWindowOpen = (visitStatus: boolean, name: string, phone: string, date: string, doctorName: string, doctorPhoto: string, id: number) => {
        setOpen(true)
        setVisited(visitStatus)
        setPatientName(name)
        setPatientPhone(phone)
        setDate(date)
        setDoctorName(doctorName)
        setDoctorPhoto(doctorPhoto)
        setRecId(id)
    }

    const handlePerform = (body: IUpdateBody) => {
        updateStatus(body)
    }
    const closeWindow = () => {
        setOpen(false)
    }

    const {data: dailyReconciliations2, isError, isLoading} = useGetDailyReconciliationsQuery(filterPage)

    const dailyReconciliations = {
        count: 2,
        next: null,
        previous: null,
        results: [
            {
                id: 1,
                patient: {
                    id: 101,
                    first_name: 'John',
                    phone: '123-456-7890'
                },
                appointment_time: '2024-06-16T09:00:00Z',
                appointment_doctor_time: {
                    id: 301,
                    doctor: {
                        id: 201,
                        first_name: 'Emily',
                        last_name: 'Smith',
                        middle_name: 'A.',
                        photo: 'https://example.com/photos/emily_smith.jpg'
                    },
                    date: '2024-06-16T09:30:00Z'
                },
                is_visited: true
            },
            {
                id: 2,
                patient: {
                    id: 102,
                    first_name: 'Jane',
                    phone: '987-654-3210'
                },
                appointment_time: '2024-06-16T10:00:00Z',
                appointment_doctor_time: {
                    id: 302,
                    doctor: {
                        id: 202,
                        first_name: 'Michael',
                        last_name: 'Brown',
                        middle_name: 'B.',
                        photo: 'https://example.com/photos/michael_brown.jpg'
                    },
                    date: '2024-06-16T10:30:00Z'
                },
                is_visited: false
            }
        ]
    };

    useEffect(() => {
        if (dailyReconciliations) {
            dispatch(setReconciliationsCount(dailyReconciliations?.count))
        }
        }, [dailyReconciliations?.count])

    return (
        <>
            <IsError isError={isError}/>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        {Object.values(mapping).map((title, idx) => {
                            return (
                                <StyledTableCell key={idx} align={"left"}>{title}</StyledTableCell>
                            )
                        })}
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {isLoading ?
                        <TableLoadingMockup cellCount={6} rowCount={rowsPerPage}/>
                        :
                        dailyReconciliations?.results?.map((item, ind) => {

                            if (
                                (query && item?.appointment_doctor_time?.doctor?.first_name?.toLowerCase().includes(query.toLowerCase()))
                                || (query && item?.appointment_doctor_time?.doctor?.last_name?.toLowerCase().includes(query.toLowerCase()))
                                || (query && item?.appointment_doctor_time?.doctor?.middle_name?.toLowerCase().includes(query.toLowerCase()))
                            ) {
                                return <Children item={item} handleWindowOpen={handleWindowOpen} key={item.id}/>
                            } else if (query === '') {
                                return <Children item={item} handleWindowOpen={handleWindowOpen} key={item.id}/>
                            } else return

                            return
                        })}
                </TableBody>
            </Table>
            {dailyReconciliations?.results.length === 0 && <div style={{padding: "10px"}}>Данных нет...</div>}
            {isOpen && <DailyReconciliationWindow
                isWindowOpen={isOpen} closeWindow={closeWindow}
                isLoading={deleteLoading}
                isError={deletingProductError}
                isSuccess={isSuccess}
                handlePerform={handlePerform}
                status={isVisited}
                patientName={patientName}
                patientPhone={patientPhone}
                date={date}
                doctorName={doctorName}
                doctorPhoto={doctorPhoto}
                recId={recId}
            />}
        </>
    );
};

type Props2 = {
    item: IDailyReconciliationsResults
    handleWindowOpen(visitStatus: boolean, name: string, phone: string, date: string, doctorName: string, doctorPhoto: string, id: number): void
}

const Children: React.FC<Props2> = ({item, handleWindowOpen}) => {
    return (
        <StyledTableRow>
            <StyledTableCell>{`${item?.appointment_doctor_time?.date}`}</StyledTableCell>
            <StyledTableCell>{`${item?.appointment_time}`}</StyledTableCell>
            <StyledTableCell>
                <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                    <img style={{
                        borderRadius: "50px",
                        height: "40px",
                        width: "40px"
                    }}
                         src={item?.appointment_doctor_time?.doctor?.photo}

                    />
                    <Typography>{`${item?.appointment_doctor_time?.doctor?.last_name} ${item?.appointment_doctor_time?.doctor?.first_name} ${item?.appointment_doctor_time?.doctor?.middle_name}`}</Typography>
                </Box>

            </StyledTableCell>
            <StyledTableCell>{`${item?.patient?.first_name} ${item?.patient?.phone}`}</StyledTableCell>
            <StyledTableCell>{statuses[`${item?.is_visited}`]}</StyledTableCell>
            <StyledTableCell>
                <Button variant={"outlined"} sx={{
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    border: "1px solid #666666",
                    color: "#666666",
                    textTransform: "capitalize"
                }} onClick={() => handleWindowOpen(item?.is_visited,
                    item.patient?.first_name,
                    item?.patient?.phone,
                    item?.appointment_doctor_time?.date,
                    `${item?.appointment_doctor_time?.doctor?.last_name} ${item?.appointment_doctor_time?.doctor?.first_name} ${item?.appointment_doctor_time?.doctor?.middle_name}`,
                    item?.appointment_doctor_time?.doctor?.photo,
                    item?.id
                )}>Редактировать</Button>
            </StyledTableCell>
        </StyledTableRow>
    )
}

export default DailyReconciliationList;
